module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-tab"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed  tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#details1"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES85UC3']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in tab-detail",
    attrs: {
      "id": "details1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "detail-block"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC3']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "dtereq",
      "name": "dtereq"
    }
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.tab1.dtereq)))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC3']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "place",
      "name": "place"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.place))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC3']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "desc_codcnty",
      "name": "desc_codcnty"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.desc_codcnty))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC3']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "input-group width-70"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.distance),
      expression: "detail.tab1.distance"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "disabled": "disabled",
      "id": "distance",
      "name": "distance"
    },
    domProps: {
      "value": (_vm.detail.tab1.distance)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab1, "distance", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon input-group-addon-cust"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC3']['60']))])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC3']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "input-group width-70"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.costkms),
      expression: "detail.tab1.costkms"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "disabled": "disabled",
      "id": "costkms",
      "name": "costkms"
    },
    domProps: {
      "value": (_vm.detail.tab1.costkms)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab1, "costkms", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon input-group-addon-cust"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC3']['80']))])]), _vm._v(" "), _c('div', {
    staticClass: "text-error",
    attrs: {
      "id": "form-errors-p_amtwidrw"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC3']['190']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "input-group width-70"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.costday),
      expression: "detail.tab1.costday"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "disabled": "disabled",
      "id": "costday",
      "name": "costday"
    },
    domProps: {
      "value": (_vm.detail.tab1.costday)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab1, "costday", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon input-group-addon-cust"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC3']['200']))])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC3']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('textarea', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "remark",
      "name": "remark",
      "disabled": "disabled"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.remark))])])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-block-float detail-block-left"
  }, [_c('div', {
    staticClass: "detail-header"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC3']['100']))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC3']['110']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "dtestrt",
      "name": "dtestrt"
    }
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.tab1.dtestrt)))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC3']['120']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "timstrt",
      "name": "timstrt"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.timstrt))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC3']['130']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "dteend",
      "name": "dteend"
    }
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.tab1.dteend)))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC3']['140']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "timend",
      "name": "timend"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.timend))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC3']['150']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "input-group width-70"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.qtyday),
      expression: "detail.tab1.qtyday"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "disabled": "disabled",
      "id": "qtyday",
      "name": "qtyday"
    },
    domProps: {
      "value": (_vm.detail.tab1.qtyday)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab1, "qtyday", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon input-group-addon-cust"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC3']['160']))])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC3']['170']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "input-group width-70"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.amtreq),
      expression: "detail.tab1.amtreq"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "disabled": "disabled",
      "id": "amtreq",
      "name": "amtreq"
    },
    domProps: {
      "value": (_vm.detail.tab1.amtreq)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab1, "amtreq", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon input-group-addon-cust"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC3']['180']))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-block-float detail-block-right"
  }, [_c('div', {
    staticClass: "detail-header"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC3']['210']))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC3']['220']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70"
  }, [_c('a', {
    attrs: {
      "href": _vm.baseURL + _vm.detail.tab1.path_filenam1,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.filenam1))])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC3']['230']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70"
  }, [_c('a', {
    attrs: {
      "href": _vm.baseURL + _vm.detail.tab1.path_filenam2,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.filenam2))])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC3']['240']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70"
  }, [_c('a', {
    attrs: {
      "href": _vm.baseURL + _vm.detail.tab1.path_filenam3,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.filenam3))])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES85UC3']['250']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text txtarea-width width-70",
    attrs: {
      "id": "descnote",
      "name": "descnote"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.descnote))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#details2"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES85UC6']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "details2"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('hrms-table', {
    attrs: {
      "columns": _vm.tab2Table,
      "data": _vm.detail.tab2.table
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.toggle('index')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-41ece757!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres85u/detail.vue
// module id = 3715
// module chunks = 1